import { create } from 'zustand';
import { User as ApiUser } from 'src/types/api/UserList';

interface SAFFEmpState {
  isAddUserModalOpen: boolean;
  filterValue: string;
  selectedUser: ApiUser | null;
  
  // Actions
  setIsAddUserModalOpen: (open: boolean) => void;
  setFilterValue: (value: string) => void;
  setSelectedUser: (user: ApiUser | null) => void;
  
  // Reset all selections
  resetSelections: () => void;
}

export const useSAFFEmpStore = create<SAFFEmpState>((set) => ({
  isAddUserModalOpen: false,
  filterValue: '',
  selectedUser: null,
  
  setIsAddUserModalOpen: (open) => set({ isAddUserModalOpen: open }),
  setFilterValue: (value) => set({ filterValue: value }),
  setSelectedUser: (user) => set({ selectedUser: user }),
  
  resetSelections: () => set({ selectedUser: null }),
}));
